const swiperLargeOption = {
  slidesPerView: 5,
  spaceBetween: 30,
  slidesPerGroup: 5,
  centeredSlides: true,
  breakpoints: {
    360: {
      slidesPerView: 1,
      slidesPerGroup: 1,
      centeredSlides: true
    },
    643: {
      slidesPerView: 2,
      slidesPerGroup: 2,
      centeredSlides: false
    },
    1024: {
      slidesPerView: 3,
      slidesPerGroup: 3,
      centeredSlides: false
    },
    1216: {
      slidesPerView: 4,
      slidesPerGroup: 4,
      centeredSlides: false
    }
  },
  pagination: {
    el: ".swiper-pagination",
    clickable: true
  },
  navigation: {
    nextEl: ".swiper-button-next",
    prevEl: ".swiper-button-prev"
  }
};

export default swiperLargeOption;
